import { createFileRoute } from "@tanstack/react-router";

import { DatasetBrowser } from "@/features/assets/DatasetBrowser";

export const Route = createFileRoute("/_authenticated/golden/judge")({
  component: () => <DatasetBrowser datasetId="llm-judge" defaultVersionId="v1" />,
});
